'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  fill: ', ';\n'], ['\n  width: ', ';\n  fill: ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  background-color: transparent;\n'], ['\n  background-color: transparent;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledSVG = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width ? props.width : '1.5rem';
}, function (props) {
  return props.theme[props.color || 'color_white'];
});
var StyledPath = _styledComponents2.default.path(_templateObject2);

// const FcRapida = (props) => (
//   <StyledSVG data-testid="ico-fc-rapida" width={props.width} id="Camada_1" data-name="Camada 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.97 203.23">
//     <defs><style>{`.cls-1{fill: #fff;}`}</style></defs><title>2ico-fc-rapida</title>
//     <StyledPath data-testid="ico-fc-rapida-path" color={props.color} d="M282.78,308c-2.3-.11-3.86-.26-5.42-.26-9.46,0-18.93,0-28.39,0-4.52,0-5.63-1.71-3.64-5.69Q270,252.66,294.6,203.35c1.39-2.79,3.42-3.8,6.36-3.8,16.39,0,32.79,0,49.18.09,1.7,0,4.15.63,4.86,1.81s-.27,3.5-1.16,4.92c-11.94,19.08-24,38.09-36,57.13-.75,1.18-1.35,2.45-2.38,4.32,2.24.19,3.76.41,5.28.42,11.06,0,22.13,0,33.19.09,1.53,0,4.13.76,4.34,1.63a6.42,6.42,0,0,1-1.43,4.87q-52.92,63.08-106.1,126c-1,1.22-3.68,2.37-4.89,1.88-2.46-1-1.12-3.3-.35-5.15q17.71-42.14,35.39-84.3C281.5,311.78,282,310.27,282.78,308Zm64.51-102.39c-2-.13-3.3-.27-4.56-.27-12.79,0-25.58.1-38.37-.08-3.29,0-5,1.11-6.44,4Q276,253.44,253.86,297.55c-.61,1.22-1,2.54-1.82,4.42h5.09c9.19,0,18.39-.05,27.58,0,4.93,0,6,1.72,4.15,6.11q-14.32,34.25-28.62,68.5c-.48,1.15-.81,2.37-1.21,3.56l1,.64,90-106.66c-2.93-.28-4.6-.57-6.26-.58-10.53,0-21.05,0-31.58-.1-1.7,0-4.22-.53-4.85-1.66s.43-3.47,1.34-4.9c11.81-18.69,23.73-37.3,35.6-55.95C345.27,209.45,346.06,207.83,347.29,205.58Z" transform="translate(-244.39 -199.55)" />
//     <StyledPath className="cls-1" d="M347.29,205.58c-1.24,2.25-2,3.87-3,5.38-11.87,18.65-23.79,37.26-35.6,55.95-.91,1.44-1.94,3.84-1.34,4.9s3.15,1.63,4.85,1.66c10.52.14,21.05.05,31.58.1,1.67,0,3.33.3,6.26.58l-90,106.66-1-.64c.4-1.19.73-2.4,1.21-3.56q14.29-34.26,28.62-68.5c1.84-4.39.78-6.07-4.15-6.11-9.19-.08-18.39,0-27.58,0H252c.77-1.88,1.21-3.19,1.82-4.42q22-44.16,44.06-88.33c1.44-2.9,3.15-4.05,6.44-4,12.79.18,25.58.07,38.37.08C344,205.31,345.26,205.45,347.29,205.58Z" transform="translate(-244.39 -199.55)" />
//   </StyledSVG>
// );
var FcRapida = function FcRapida(props) {
  return _react2.default.createElement(StyledSVG, Object.assign({}, props, {
    'data-testid': 'ico-fc-rapida',
    width: props.width,
    viewBox: '0 0 451 451'
  }), _react2.default.createElement('g', null, _react2.default.createElement(StyledPath, {
    'data-testid': 'ico-fc-rapida-path',
    d: 'M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3   s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4   C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3   s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z'
  })));
};
exports.default = FcRapida;